import {useState, useEffect} from 'react';

import './ChatProgress.css';

interface Props {
  certainty: number | null;
  done: boolean;
  passThreshold: number;
  seeResultsLabel: string;
  resultsHint: string;
  progressDescription: string;
  onSeeResults: () => void;
}

export const ChatProgress = ({
  certainty,
  done,
  passThreshold,
  seeResultsLabel,
  resultsHint,
  progressDescription,
  onSeeResults,
}: Props) => {
  const progress = certainty ?? 0;
  const canSeeResults = done || (certainty !== null && certainty >= passThreshold);
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    if (canSeeResults) {
      setShowHint(true);
    }
  }, [canSeeResults]);

  return (
    <div className='chat-progress'>
      <span className='chat-progress__hint'>{progressDescription}</span>
      <div className='chat-progress__row'>
        <div className='chat-progress__track'>
          <div className='chat-progress__fill' style={{width: `${progress}%`}} />
        </div>
        <span className='chat-progress__label'>{progress}%</span>
        <div className='chat-progress__btn-wrapper'>
          {showHint && (
            <div className='chat-progress__popover' role='tooltip'>
              <span>{resultsHint}</span>
              <button className='chat-progress__popover-close' aria-label='Dismiss' onClick={() => setShowHint(false)}>
                ×
              </button>
            </div>
          )}
          <button className='chat-progress__btn' disabled={!canSeeResults} onClick={onSeeResults}>
            {seeResultsLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
